import * as React from 'react';
import type { WidgetProps } from '@rjsf/utils';
import { Slider } from '@/components/ui/slider';

export default function SliderWidget(props: WidgetProps) {
  const { id, value, schema, onChange, disabled, readonly, options, required } = props;
  const min = (schema as any)?.minimum ?? (options as any)?.min ?? 0;
  const max = (schema as any)?.maximum ?? (options as any)?.max ?? 100;
  const step = (options as any)?.step ?? 1;
  const v = typeof value === 'number' ? value : (schema as any)?.default ?? min;

  return (
    <div className="grid gap-2">
      <Slider
        value={[v as number]}
        min={min as number}
        max={max as number}
        step={step as number}
        onValueChange={(vals) => onChange(vals && vals.length ? vals[0] : (required ? min : undefined))}
        disabled={disabled || readonly}
        aria-labelledby={id}
      />
      <div className="text-xs text-muted-foreground">{String(v)}</div>
    </div>
  );
}
